var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173286",
    "data-name": "Group 173286",
    transform: "translate(19989 18734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144976",
    "data-name": "Rectangle 144976",
    width: 12,
    height: 12,
    transform: "translate(-19989 -18734)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "replicate_1_",
    "data-name": "replicate (1)",
    transform: "translate(-19987.285 -18732.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21295",
    "data-name": "Path 21295",
    d: "M25.224,3.837h.612V2.612A.613.613,0,0,0,25.224,2H24v.612h1.224Z",
    transform: "translate(-17.265 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144974",
    "data-name": "Rectangle 144974",
    width: 1.224,
    height: 0.612,
    transform: "translate(4.592 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144975",
    "data-name": "Rectangle 144975",
    width: 0.612,
    height: 1.224,
    transform: "translate(7.959 2.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21296",
    "data-name": "Path 21296",
    d: "M9.959,6.9V8.122H8.735V4.449a.613.613,0,0,0-.612-.612H4.449V2.612H5.673V2H4.449a.613.613,0,0,0-.612.612V3.837H2.612A.613.613,0,0,0,2,4.449v5.51a.613.613,0,0,0,.612.612h5.51a.613.613,0,0,0,.612-.612V8.735H9.959a.613.613,0,0,0,.612-.612V6.9ZM8.122,9.959H2.612V4.449h5.51Z",
    transform: "translate(-2 -2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/Clone.5074a31d46512d2c73ce7b8c0be5c6b3.svg";
export { ForwardRef as ReactComponent };